export class StatWidget {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "value",
            "baseName": "value",
            "type": "number",
            "format": "double"
        },
        {
            "name": "deltaText",
            "baseName": "deltaText",
            "type": "string",
            "format": ""
        },
        {
            "name": "subText",
            "baseName": "subText",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetPage",
            "baseName": "targetPage",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StatWidget.attributeTypeMap;
    }
    constructor() {
    }
}
